import React from 'react';
import { DescriptionSection } from '../styles';

type FormDescriptionSectionProps = {
  title?: string | null;
  description?: string | null;
};

export const FormDescriptionSection: React.FC<FormDescriptionSectionProps> = ({
  title,
  description,
}) => {
  if (!title && !description) return null;

  return (
    <DescriptionSection>
      {title && <h3>{title}</h3>}
      {description && (
        <p
          dangerouslySetInnerHTML={{
            __html: description.replace(/\n/g, '<br />'),
          }}
        />
      )}
    </DescriptionSection>
  );
};
